import capitalize from "lodash/fp/capitalize";
import lowerCase from "lodash/fp/lowerCase";

class Titlize {
  constructor() {
    return this.transform;
  }

  transform(text) {
    return capitalize(lowerCase(text));
  }
}

const titlizeFnc = () => new Titlize();

export default titlizeFnc;



// WEBPACK FOOTER //
// ./src/filters/titlize/titlize.filter.js